import { TooltipContext } from './TooltipContext';
import { View } from 'react-native';
import { useTooltipProviderLogic } from './TooltipProvider.logic';

export function TooltipProvider({ children }: { children: React.ReactNode }) {
  const { TooltipContent, contextValue, setTooltipLayout, tooltipStyle, arrowStyle, tooltipId } =
    useTooltipProviderLogic();

  return (
    <TooltipContext.Provider value={contextValue}>
      {children}
      <View testID={tooltipId} onLayout={event => setTooltipLayout(event.nativeEvent.layout)} style={tooltipStyle}>
        {!!TooltipContent && (
          <>
            <View style={arrowStyle} />
            <TooltipContent onClose={contextValue.closeTooltip} />
          </>
        )}
      </View>
    </TooltipContext.Provider>
  );
}
